var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useDispatch } from "react-redux";
import LocalStorageService from "../../../../services/localStorage";
import { projectOneClearData } from "../../../../store/project/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { backStepById, updateNextStepInformation, updateStepByPath, useGetInformationSteps, } from "ah_utility/workflow";
import { useCompleteStep } from "../../../../utils/responseComplete";
import { useStepNavigation } from "ah_utility/NavigationEngine";
var useUI = function (setDocumentCode, setOpenDrawer, setOpenModal, setIdDocument, setUrlDocument, Steps, setRows, idQuoteParams, STEP) {
    var dispatch = useDispatch();
    var storageKey = "assurehub";
    var navigate = useNavigate();
    var localStorageService = new LocalStorageService(storageKey);
    var pathname = useLocation().pathname;
    var _a = useCompleteStep(), runComplete = _a.runComplete, loadingComplete = _a.loadingComplete;
    var _b = useGetInformationSteps(pathname), instanceId = _b.instanceId, workFlowId = _b.workFlowId, currentStep = _b.currentStep, nextStep = _b.nextStep;
    var dataNavigation = useStepNavigation({ currentStepId: pathname }).navigation;
    var handleClickContextMenu = function (item, params) {
        switch (item.id) {
            case "1":
                setDocumentCode(params.row.code);
                setOpenDrawer(true);
                break;
            case "2":
                setOpenModal(true);
                setIdDocument(params.row.id);
                setUrlDocument(params.row.url);
                // navigate(
                //   `/visor-pdf/${params.row.id}/${
                //     idQuoteParams ? idQuoteParams : quoteId
                //   }`,
                // );
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.auditDocumentUrl,
                //   completed: true,
                //   auditDocumentUrl: params.row.url,
                // });
                break;
            case "3":
                console.log("case3", item, params.row);
                break;
            default:
                break;
        }
    };
    var setProjectRows = function (responseOneProject) {
        var DocumentRows = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.map(function (item, index) { return ({
            id: index.toString(),
            code: item.code,
            docType: item.document,
            state: item.state ? item.state : "Sin documento",
            date: item.dateUpdated,
            user: item.user,
            comments: item.comentario,
        }); });
        setRows(DocumentRows);
        dispatch(projectOneClearData());
    };
    var onCloseDrawer = function () {
        setOpenDrawer(false);
    };
    var onClickButtonBack = function () {
        if (idQuoteParams) {
            navigate("/insurance-policies-summary");
        }
        backStepById(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    var onClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, err_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 1:
                    res = _d.sent();
                    if (res) {
                        updateStepByPath(pathname);
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        updateNextStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _d.sent();
                    console.error("Error completing step:", err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        handleClickContextMenu: handleClickContextMenu,
        setProjectRows: setProjectRows,
        onCloseDrawer: onCloseDrawer,
        onClickButtonBack: onClickButtonBack,
        onClickNext: onClickNext,
    };
};
export default useUI;
